<template>
  <v-container>

    <template v-if="devices.length">

      <v-data-table
        :headers="headers"
        :items="devices"
        :options.sync="options"
        :items-per-page="15"
        :server-items-length="totalDevices"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-btn color="primary" :to="`/devices/new`" class="ma-4">
            {{ $t('devices.list.newDevice') }}
          </v-btn>
        </template>

        <template v-slot:item.open="{ item }">
          <v-btn icon small :to="`/devices/${item.id}`" >
            <v-icon>
              mdi-eye
            </v-icon>
          </v-btn>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn
            icon
            small
            class="mr-2"
            :to="`/devices/${item.id}/update`">
            <v-icon
              small
            >
              mdi-pencil
            </v-icon>
          </v-btn>
          <v-icon
            small
            @click="deleteDevice(item)"
          >
            mdi-delete
          </v-icon>
        </template>

        <template v-slot:item.createdAt="{ item }">
          <span>{{ new Date(item.createdAt).toLocaleString() }}</span>
        </template>

        <template v-slot:item.updatedAt="{ item }">
          <span>{{ new Date(item.updatedAt).toLocaleString() }}</span>
        </template>
      </v-data-table>

    </template>

    <template v-else>
      <v-row justify="center" align="center" class="max-height">
        {{ $t('devices.list.noDevice') }}
        <v-btn plain color="primary" to="/devices/new">
          {{ $t('devices.list.newDevice') }}
        </v-btn>
      </v-row>
    </template>

  </v-container>
</template>

<script>
import i18n from '@/i18n';

export default {
  name: 'DeviceListPage',
  components: {},
  watch: {
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
  },
  data: () => ({
    dialog: false,
    options: {},
  }),
  created() {
    this.$store.dispatch('device/listDevices', {});
  },
  computed: {
    devices() {
      return this.$store.state.device.devices;
    },
    totalDevices() {
      return this.$store.state.device.totalDevices;
    },
    loading() {
      return this.$store.state.device.loading;
    },
    language() {
      return this.$i18n.locale;
    },
    headers() {
      return [
        {
          text: i18n.t('devices.list.open'),
          value: 'open',
          sortable: false,
        },
        {
          text: i18n.t('devices.list.name'),
          value: 'name',
          sortable: false,
        },
        {
          text: i18n.t('devices.list.uuid'),
          value: 'uuid',
          sortable: false,
        },
        {
          text: i18n.t('devices.list.major'),
          value: 'major',
          sortable: false,
        },
        {
          text: i18n.t('devices.list.minor'),
          value: 'minor',
          sortable: false,
        },
        {
          text: i18n.t('devices.list.createdAt'),
          value: 'createdAt',
          sortable: false,
        },
        {
          text: i18n.t('devices.list.updatedAt'),
          value: 'updatedAt',
          sortable: false,
        },
        { text: i18n.t('devices.list.actions'), value: 'actions', sortable: false },
      ];
    },
  },
  methods: {
    getDataFromApi() {
      const {
        page, itemsPerPage,
      } = this.options;
      this.$store.dispatch('device/listDevices', {
        page,
        itemsPerPage,
      });
    },

    async deleteDevice({ id, name }) {
      if (await this.$root.$confirm.open(
        i18n.t('common.delete'),
        i18n.t('devices.deleteConfirm'),
        { color: 'red', itemName: name },
      )) {
        await this.$store.dispatch('device/deleteDevice', { id });

        // If the removed item was the last one in the page we need to go to the previous page
        if (this.devices.length - 1 <= 0 && this.options.page > 1) {
          this.options.page -= 1;
        }

        this.getDataFromApi();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  .max-height {
    height: 100%;
  }
}
</style>
